<template>
  <label :class="{'file-upload-html5': $mode == 'html5', 'file-upload-html4': $mode == 'html4', 'active': active, 'uploaded':model,'has-delete': hasDelete}" class="file-upload">
    <input-file v-if="(!model&&hasDelete)||(!hasDelete)"></input-file>
    <div class="delete uploading" v-if="model && hasDelete" @click.stop="deleteImg"></div>
    <div class="uploading" v-if="active">
      <span class="tip" v-if="showTip">上传中 {{files[0].progress}}%</span>
      <div class="progress" :style="{width:files[0].progress + '%'}"></div>
    </div>
    <!-- <img v-if="uploaded && files[0]" :src="srcPath+'/'+files[0].data.result + '?imageView2/1/w/50/h/50' "> -->
    <img v-if="model && !active" :src="model.replace('http://', 'https://') + suffix">
  </label>
</template>

<style scoped>
.file-upload {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  text-align: center;
  display: inline-block;
  border: 1px solid #ddd;
  color: #ddd;
  background: #fff;
  width: 52px;
  height: 52px;
  line-height: 50px;
  cursor: pointer;
}
.file-upload img{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.delete {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
}
.file-upload.has-delete.uploaded:hover:before{
  content: "删除";
  font-size: 12px;
  font-weight: bold;
  color: #0078b6;
  background-color: rgba(255,255,255,0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 2;
}
.file-upload.uploaded:hover:before{
  content: "重传";
  font-size: 12px;
  font-weight: bold;
  color: #0078b6;
  background-color: rgba(255,255,255,0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 2;
}
.file-upload.uploaded:before,
.file-upload.active:before{
  content: "";
}
.file-upload:before{
  content: "+";
  font-size: 24px;
}
.file-upload:hover {
  background-color: #f2f2f2;
}
.file-upload span{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
/*.file-upload input::-webkit-file-upload-button,*/
.file-upload input[type=file]{
  z-index: 1;
  opacity: 0;
  font-size: 20em;
  left: -9999px;
  /*top: 0;
     right: 0;
     bottom: 0;*/
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
/*.file-upload.file-upload-html5 input{
   float: left;
   width: 1px !important;
   height: 1px !important;
   top:-1px !important;
   left:-1px !important;
   right:auto !important;
   bottom:auto !important;
   }*/
.uploading span{
  display: inline-block;
  line-height: 1.4;
  transform: translate(0, -50%);
  margin-top: 50%;
  position: relative;
  color: #999;
  font-size: 6px;
}
.uploading .progress{
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #9ed6a1;
}
</style>

<script>
/* eslint-disable */
import {post, get} from '@/common/utils/Http';

export default {
  props: {
    title: {
      type: String,
      default: 'Upload file',
    },
    name: {
      type: String,
      default: 'file',
    },
    drop: {
      default: false,
    },
    extensions: {
      default: () => [],
    },
    postAction: {
      type: String,
      default: '/qiniu/upload',
    },
    putAction: {
      type: String,
    },
    accept: {
      type: String,
      default: 'image/png,image/gif,image/jpeg,image/jpg',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 10485760,
    },
    uploadConfig: {
      type: String,
      default: '/qiniu/getUploadConfig',
    },
    uploadType: {
      type: String,
    },
    events: {
      type: Object,
      default: () => {},
    },
    srcPath: {
      type: String,
      default: 'https://qiniu.drip.im',
    },
    model: {
      type: String,
      default: null,
    },
    cloud: {
      type: String,
      default: 'qiniu',
    },
    showTip: {
      type: Boolean,
      default: true,
    },
    afterUpload: {
      type: Function,
      default: (file, comp) => {
        comp.model = comp.srcPath + '/' + file.data.result;
      },
    },
  },
  components: {
    inputFile: {
      template: '<input type="file" :name="$parent.name" :id="$parent.id||$parent.name" :accept="$parent.accept" @change="change" :multiple="$parent.multiple && $parent.$mode == \'html5\'">',
      methods: {
        change(e) {
          this.$parent._addFileUploads(e.target);
          this.$parent.active = true;
          this.$destroy();
        },
      },
    },
  },

  data() {
    return {
      files: [],
      active: false,
      uploaded: true,
      dropActive: false,
      dropElement: false,
      request: {
        data: {},
        headers: {},
      },
    };
  },

  computed: {
    suffix() {
      return this.model.indexOf('qiniu') !== -1
           ? '?imageView2/1/w/50/h/50'
           : '';
    },
  },

  mounted() {
    this._drop(this.drop);
  },

  beforeCreate() {
    const input = document.createElement('input');
    input.type = 'file';
    if (window.FormData && input.files) {
      this.$mode = 'html5';
    } else {
      this.$mode = 'html4';
    }
    this._index = 0;
    this._dropActive = 0;
    this._files = {};
  },

  beforeDestroy() {
    this.active = false;
    this.files = [];
  },

  watch: {
    drop(value) {
      this._drop(value);
    },
    files(files) {
      const ids = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!file.errno && !file.success) {
          this.uploaded = false;
        }
        ids.push(file.id);
      }
      for (const id in this._files) {
        if (ids.indexOf(id) !== -1) {
          continue;
        }

        const file = this._files[id]._file;

        file.removed = true;
        const xhr = this._files[id].xhr;
        if (xhr) {
          xhr.abort();
          xhr.timeout = 1;
        }
        const iframe = this._files[id].iframe;
        if (iframe) {
          iframe.onabort({type: 'abort'});
        }
        delete this._files[id];
        this.uploadEvents('removeFileUpload', file);
      }
      this._index = 0;
    },

    active(newValue, oldValue) {
      if (newValue && !oldValue) {
        this._fileUploads();
      }
    },

    uploaded(uploaded) {
      if (uploaded) {
        this.active = false;
      }
    },
  },
  methods: {
    deleteImg() {
      this.$emit('deletemodel', true);
    },
    getFilesSrc() {
      const src = [];
      const path = this.srcPath;
      for (const file of this.files) {
        if (file && file.data && file.data.success) {
          src.push(path + '/' + file.data.result);
        }
      }
      return src;
    },
    clear() {
      if (this.files.length) {
        this.files.splice(0, this.files.length);
      }
    },

    uploadEvents(name, file) {
      if (this.$dispatch) {
        this.$dispatch(name, file, this);
      }
      if (this[name]) {
        this[name](file);
      }
      if (this.events && this.events[name]) {
        this.events[name](file, this);
      }
    },

    _drop(value) {
      if (this.dropElement && this.$mode === 'html5') {
        try {
          window.document.removeEventListener('dragenter', this._onDragenter, false);
          window.document.removeEventListener('dragleave', this._onDragleave, false);
          this.dropElement.removeEventListener('dragover', this._onDragover, false);
          this.dropElement.removeEventListener('drop', this._onDrop, false);
        } catch (e) {
        }
      }

      if (!value) {
        this.dropElement = false;
        return;
      }

      if (typeof value === 'string') {
        this.dropElement = document.querySelector(value) || this.$root.$el.querySelector(value);
      } else if (typeof value === 'boolean') {
        this.dropElement = this.$parent.$el;
      } else {
        this.dropElement = this.drop;
      }
      if (this.dropElement && this.$mode === 'html5') {
        window.document.addEventListener('dragenter', this._onDragenter, false);
        window.document.addEventListener('dragleave', this._onDragleave, false);
        this.dropElement.addEventListener('dragover', this._onDragover, false);
        this.dropElement.addEventListener('drop', this._onDrop, false);
      }
    },
    _onDragenter(e) {
      this._dropActive++;
      this.dropActive = !!this._dropActive;
      e.preventDefault();
    },
    _onDragleave(e) {
      e.preventDefault();
      this._dropActive--;
      if (e.target.nodeName === 'HTML' || (e.screenX === 0 && e.screenY === 0)) {
        this.dropActive = !!this._dropActive;
      }
    },
    _onDragover(e) {
      e.preventDefault();
    },

    _addFileUpload(hiddenData, file) {
      const defaultFile = {
        size: -1,
        name: 'Filename',
        progress: 0,
        speed: 0,
        active: false,
        error: '',
        errno: '',
        success: false,
        data: {},
        request: {
          headers: {},
          data: {},
        },
      };
      for (const key in defaultFile) {
        if (typeof file[key] === 'undefined') {
          file[key] = defaultFile[key];
        }
      }
      if (!file.id) {
        file.id = Math.random().toString(36).substr(2);
      }

      if (!this.multiple) {
        this.clear();
      }

      this._files[file.id] = hiddenData;
      file = this.files[this.files.push(file) - 1];
      this._files[file.id]._file = file;
      this.uploadEvents('addFileUpload', file);
    },
    _onDrop(e) {
      this._dropActive = 0;
      this.dropActive = false;
      e.preventDefault();
      if (e.dataTransfer.files.length) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          const file = e.dataTransfer.files[i];
          this._addFileUpload({file}, {size: file.size, name: file.name});
          if (!this.multiple) {
            break;
          }
        }
      }
    },

    _addFileUploads(el) {
      this.uploaded = false;

      if (el.files) {
        for (let i = 0; i < el.files.length; i++) {
          const file = el.files[i];
          this._addFileUpload({file, el}, {size: file.size, name: file.name});
        }
      } else {
        this._addFileUpload({el}, {size: -1, name: el.value.replace(/^.*?([^/\\\r\n]+)$/, '$1')});
      }
    },

    _fileUploads() {
      if (!this.active) {
        return;
      }
      for (; this._index < this.files.length; this._index++) {
        const file = this.files[this._index];
        if (file.active || file.success || file.errno) {
          continue;
        }
        if (this.size && this.size > 0 && file.size >= 0 && file.size > this.size) {
          file.error = 'Size';
          file.errno = 'size';
          const size = parseInt(this.size / 1000 / 1000);
          this.$notify.alarm('图片不允许超过' + size + 'M');
          continue;
        }

        if (this.extensions && (this.extensions.length || typeof this.extensions.length === 'undefined')) {
          let extensions = this.extensions;
          if (typeof extensions === 'object' && extensions instanceof RegExp) {

          } else {
            if (typeof extensions === 'string') {
              extensions = extensions.split(',').map(function(value) {
                return value.trim();
              }).filter(function(value) {
                return value;
              });
            }
            extensions = new RegExp('\\.(' + extensions.join('|').replace(/\./g, '\\.') + ')$', 'i');
          }

          if (file.name.search(extensions) === -1) {
            file.error = 'Extension';
            file.errno = 'extension';
            continue;
          }
        }

        if (this.$mode === 'html5') {
          if (this.putAction || file.putAction) {
            this._fileUploadPut(file);
          } else if (this.postAction || file.postAction) {
            if (this.uploadType === 'qiniuDirect') {
              this._fileUploadHtml5QiniuDirect(file);
            } else {
              this._fileUploadHtml5(file);
            }
          } else {
            file.error = 'Not Support';
            file.errno = 'not_support';
            continue;
          }
        } else {
          if (this.postAction || file.postAction) {
            this._fileUploadHtml4(file);
          } else {
            file.error = 'Not Support';
            file.errno = 'not_support';
            continue;
          }
        }
        return;
      }
      this.active = false;
      this.uploaded = true;
    },

    _fileUploadXhr(xhr, file, data) {
      const _self = this;
      const hiddenData = this._files[file.id];
      let fileUploads = false;
      let speedTime = 0;
      let speedLoaded = 0;
      xhr.upload.onprogress = function(e) {
        if (file.removed) {
          xhr.abort();
          return;
        }
        if (!_self.active || !file.active) {
          xhr.abort();
          return;
        }
        if (e.lengthComputable) {
          // file.progress = (e.loaded / e.total * 100).toFixed(2)
          file.progress = parseInt(e.loaded / e.total * 100);
          const speedTime2 = Math.round(Date.now() / 1000);
          if (speedTime2 !== speedTime) {
            file.speed = e.loaded - speedLoaded;
            speedLoaded = e.loaded;
            speedTime = speedTime2;
          }
        }
        _self.uploadEvents('fileUploadProgress', file);
        // _self.onFileProgress(file)
      };

      const callback = function(e) {
        switch (e.type) {
          case 'timeout':
            file.errno = 'timeout';
            file.error = 'Timeout';
            break;
          case 'abort':
            file.errno = 'abort';
            file.error = 'Abort';
            break;
          case 'error':
            if (!xhr.status) {
              file.errno = 'network';
              file.error = 'Network';
            } else if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            }
            break;
          default:
            if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            } else {
              file.progress = 100;
              file.success = true;
            }
        }
        file.active = false;
        if (xhr.responseText) {
          const contentType = xhr.getResponseHeader('Content-Type');
          if (contentType && contentType.indexOf('/json') !== -1) {
            file.data = JSON.parse(xhr.responseText);
          } else {
            file.data = xhr.responseText;
          }
        }
        if (!fileUploads) {
          fileUploads = true;
          if (!file.removed) {
            _self.uploadEvents('afterFileUpload', file);
            _self.$emit('afterUpload', file, _self);
          }
          setTimeout(function() {
            _self._fileUploads();
          }, 50);
        }
      };

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      for (const key in this.request.headers) {
        xhr.setRequestHeader(key, this.request.headers[key]);
      }
      for (const key in file.request.headers) {
        xhr.setRequestHeader(key, file.request.headers[key]);
      }

      xhr.send(data);
      file.active = true;
      hiddenData.xhr = xhr;
      const interval = setInterval(function() {
        if (!_self.active || !file.active || file.success || file.errno) {
          clearInterval(interval);
          if (!file.success && !file.errno) {
            xhr.abort();
          }
        }
      }, 100);
      _self.$emit('fileUploadProgress', file);
      this.uploadEvents('beforeFileUpload', file);
    },
    // 七牛文件直传的方法，和上面请求的方法一样，只是对不同的 Response 做了不同的处理
    _fileUploadXhrQiniuDirect(xhr, file, data) {
      const _self = this;
      const hiddenData = this._files[file.id];
      let fileUploads = false;
      let speedTime = 0;
      let speedLoaded = 0;
      xhr.upload.onprogress = function(e) {
        if (file.removed) {
          xhr.abort();
          return;
        }
        if (!_self.active || !file.active) {
          xhr.abort();
          return;
        }
        if (e.lengthComputable) {
          // file.progress = (e.loaded / e.total * 100).toFixed(2)
          file.progress = parseInt(e.loaded / e.total * 100);
          const speedTime2 = Math.round(Date.now() / 1000);
          if (speedTime2 !== speedTime) {
            file.speed = e.loaded - speedLoaded;
            speedLoaded = e.loaded;
            speedTime = speedTime2;
          }
        }
        _self.uploadEvents('fileUploadProgress', file);
        // _self.onFileProgress(file)
      };

      const callback = function(e) {
        switch (e.type) {
          case 'timeout':
            file.errno = 'timeout';
            file.error = 'Timeout';
            break;
          case 'abort':
            file.errno = 'abort';
            file.error = 'Abort';
            break;
          case 'error':
            if (!xhr.status) {
              file.errno = 'network';
              file.error = 'Network';
            } else if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            }
            break;
          default:
            if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            } else {
              file.progress = 100;
              file.success = true;
            }
        }
        file.active = false;
        if (xhr.responseText) {
          const contentType = xhr.getResponseHeader('Content-Type');
          if (contentType && contentType.indexOf('/json') !== -1) {
            file.data.result = JSON.parse(xhr.responseText).key;
          } else {
            file.data = xhr.responseText;
          }
        }
        if (!fileUploads) {
          fileUploads = true;
          if (!file.removed) {
            _self.uploadEvents('afterFileUpload', file);
            _self.$emit('afterUpload', file, _self);
          }
          setTimeout(function() {
            _self._fileUploads();
          }, 50);
        }
      };

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      for (const key in this.request.headers) {
        xhr.setRequestHeader(key, this.request.headers[key]);
      }
      for (const key in file.request.headers) {
        xhr.setRequestHeader(key, file.request.headers[key]);
      }
      xhr.send(data);
      file.active = true;
      hiddenData.xhr = xhr;
      const interval = setInterval(function() {
        if (!_self.active || !file.active || file.success || file.errno) {
          clearInterval(interval);
          if (!file.success && !file.errno) {
            xhr.abort();
          }
        }
      }, 100);
      _self.$emit('fileUploadProgress', file);
      this.uploadEvents('beforeFileUpload', file);
    },
    _fileUploadPut(file) {
      const querys = {};
      for (const key in this.request.data) {
        querys[key] = this.request.data[key];
      }
      for (const key in file.request.data) {
        querys[key] = file.request.data[key];
      }
      const queryArray = [];
      for (const key in querys) {
        if (querys[key] !== null && typeof querys[key] !== 'undefined') {
          queryArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(querys[key]));
        }
      }
      const queryString = queryArray.length ? '?' + queryArray.join('&') : '';

      const xhr = new window.XMLHttpRequest();
      xhr.open('PUT', (file.putAction || this.putAction) + queryString);
      this._fileUploadXhr(xhr, file, this._files[file.id].file);
    },

    _fileUploadHtml5(file) {
      const form = new window.FormData();
      form.append(this.name, this._files[file.id].file);
      for (const key in this.request.data) {
        form.append(key, this.request.data[key]);
      }

      for (const key in file.request.data) {
        form.append(key, file.request.data[key]);
      }

      const xhr = new window.XMLHttpRequest();
      xhr.open('POST', file.postAction || this.postAction);
      this._fileUploadXhr(xhr, file, form);
    },

    _fileUploadHtml5QiniuDirect(file) {
      const form = new window.FormData();
      form.append(this.name, this._files[file.id].file);
      for (const key in this.request.data) {
        form.append(key, this.request.data[key]);
      }

      for (const key in file.request.data) {
        form.append(key, file.request.data[key]);
      }
      // 从后台获取文件上传的 key 和 token
      post(this.uploadConfig)({
        name: this._files[file.id].file.name,
        fsizeLimit: this.size,
      }).success((r) => {
        if (r) {
          const xhr = new window.XMLHttpRequest();
          form.append('key', r.key);
          form.append('token', r.token);
          xhr.open('POST', file.postAction || this.postAction);
          this._fileUploadXhrQiniuDirect(xhr, file, form);
        }
      });
    },

    _fileUploadHtml4(file) {
      const _self = this;
      const hiddenData = this._files[file.id];

      let fileUploads = false;

      const keydown = function(e) {
        if (e.keyCode === 27) {
          e.preventDefault();
        }
      };

      const iframe = document.createElement('iframe');
      iframe.id = 'upload-iframe-' + file.id;
      iframe.name = 'upload-iframe-' + file.id;
      iframe.src = 'about:blank';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.top = '-9999px';
      iframe.style.left = '-9999px';
      iframe.style.position = 'absolute';
      iframe.style.marginTop = '-9999em';

      const form = document.createElement('form');
      form.action = file.postAction || this.postAction;
      form.name = 'upload-form-' + file.id;
      form.setAttribute('method', 'POST');
      form.setAttribute('target', 'upload-iframe-' + file.id);
      form.setAttribute('enctype', 'multipart/form-data');
      form.appendChild(hiddenData.el);
      for (const key in this.request.data) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = this.request.data[key];
        form.appendChild(input);
      }

      for (const key in file.request.data) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = file.request.data[key];
        form.appendChild(input);
      }

      const getDocumentData = function() {
        let doc;
        try {
          if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
          }
        } catch (err) {
        }
        if (!doc) {
          try {
            doc = iframe.contentDocument ? iframe.contentDocument : iframe.document;
          } catch (err) {
            doc = iframe.document;
          }
        }
        if (doc && doc.body) {
          return doc.body.innerHTML;
        }
        return null;
      };

      const callback = function(e) {
        let data;
        switch (e.type) {
          case 'abort':
            file.errno = 'abort';
            file.error = 'Abort';
            break;
          case 'error':
            data = getDocumentData();
            if (file.errno) {

            } else if (data === null) {
              file.errno = 'network';
              file.error = 'Network';
            } else {
              file.errno = 'denied';
              file.error = 'Denied';
            }
            break;
          default:
            data = getDocumentData();
            if (file.errno) {

            } else if (data === null) {
              file.errno = 'network';
              file.error = 'Network';
            } else {
              file.progress = 100;
              file.success = true;
            }
        }

        file.active = false;
        if (typeof data !== 'undefined') {
          if (data && data.substr(0, 1) === '{' && data.substr(data.length - 1, 1) === '}') {
            try {
              data = JSON.parse(data);
            } catch (err) {
            }
          }
          file.data = data;
        }
        if (!fileUploads) {
          document.body.removeEventListener('keydown', keydown);
          document.body.removeEventListener('keydown', keydown);
          fileUploads = true;
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
          if (!file.removed) {
            _self.uploadEvents('afterFileUpload', file);
          }
          setTimeout(function() {
            _self._fileUploads();
          }, 50);
        }
      };

      setTimeout(function() {
        document.body.appendChild(iframe).appendChild(form).submit();
        iframe.onload = callback;
        iframe.onerror = callback;
        iframe.onabort = callback;

        file.active = true;

        hiddenData.iframe = iframe;

        document.body.addEventListener('keydown', keydown);
        const interval = setInterval(function() {
          if (!_self.active || !file.active || file.success || file.errno) {
            clearInterval(interval);
            if (!file.success && !file.errno) {
              iframe.onabort({type: 'abort'});
            }
          }
        }, 50);
        _self.uploadEvents('beforeFileUpload', file);
      }, 10);
    },
  },
};
</script>
